// utils.js or helper.js

export default {
    getDomainPattern(){
        return /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/)?$/;
    }
  };
    